import * as modules from './modules';

/**
 * すべての Action をまとめたもの
 */
export const Actions = {
    pastHealthCheckStatus: modules.pastHealthCheckStatus.actions,
    todayHealthCheckStatus: modules.todayHealthCheckStatus.actions,
};